import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';

// Shared layout (Navbar + Footer)
import Layout from './components/Layout';

// Main homepage components
import HeroSlider from './components/HeroSlider';
import Services from './components/Services';
import FeaturedPackages from './components/FeaturedPackages';
import WhyChooseUs from './components/WhyChooseUs';
import IndianDestinations from './components/IndianDestinations';
import InternationalDestinations from './components/InternationalDestinations';
import VisaServices from './components/VisaServices';
import Testimonials from './components/Testimonials';

// Full pages
import ItineraryPage from './components/ItineraryPage';
import FlightInquiry from './components/FlightInquiry';
import VisaPage from './components/VisaPage';
import AboutPage from './components/AboutPage';
import ContactPage from './components/ContactPage';
import AllPackagesPage from './components/AllPackagesPage';
import ShortBreakPage from './components/ShortBreakPage';

// Admin Panel (no Layout wrapper — has its own shell)
import AdminApp from './admin/AdminApp';

// Feedback Form
import FeedbackForm from './feedback/FeedbackForm';

/* ── Homepage sections (inside Layout) ────── */
function HomeContent() {
  return (
    <div className="App">
      <main className="main-content">
        <HeroSlider />
        <Services />
        <FeaturedPackages />
        <WhyChooseUs />
        <IndianDestinations />
        <InternationalDestinations />
        <VisaServices />
        <Testimonials />
      </main>
    </div>
  );
}

/* ── App with Router ───────────────────────── */
function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Admin Panel — no Layout wrapper */}
        <Route path="/admin" element={<AdminApp />} />
        <Route path="/feedback" element={<FeedbackForm />} />

        {/* Public site — wrapped in Layout (Navbar + Footer) */}
        <Route path="/" element={<Layout><HomeContent /></Layout>} />
        <Route path="/itinerary/:destination" element={<Layout><ItineraryPage /></Layout>} />
        <Route path="/packages" element={<Layout><AllPackagesPage /></Layout>} />
        <Route path="/shortbreak" element={<Layout><ShortBreakPage /></Layout>} />
        <Route path="/flights" element={<Layout><FlightInquiry /></Layout>} />
        <Route path="/visa" element={<Layout><VisaPage /></Layout>} />
        <Route path="/about" element={<Layout><AboutPage /></Layout>} />
        <Route path="/contact" element={<Layout><ContactPage /></Layout>} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
